$(window).scroll(function () {
    var header = $(".header");
    if ($(this).scrollTop() > 0) {
        $(header).addClass("js-sticky");
    } else {
        $(header).removeClass("js-sticky");
    }
});

var langCurrent = $(".lang-sel__current");
var langToggle = $(".lang-sel__toggle");

$(langCurrent).click(function () {
    $(langToggle).toggleClass("js-show");
    $(langCurrent).toggleClass("js-show");
});

var menuToggle = $(".m-toggle");
var menu = $(".menu");
var menuHamb = $("#mobileMainMenu");
var menuOverlay = $(".m-hamb-overlay");

function openMobileMenu() {
    menuToggle.addClass("js-open").attr("aria-expanded", "true");
    menuHamb.removeClass("translate-x-full").addClass("translate-x-0");
    menuOverlay.removeClass("opacity-0 pointer-events-none").addClass("opacity-100 pointer-events-auto");
    menuToggle.find(".icon-burger").addClass("hidden");
    menuToggle.find(".icon-close").removeClass("hidden").addClass("flex");
    $("body").addClass("overflow-hidden");
}

function closeMobileMenu() {
    menuToggle.removeClass("js-open").attr("aria-expanded", "false");
    menuHamb.removeClass("translate-x-0").addClass("translate-x-full");
    menuOverlay.removeClass("opacity-100 pointer-events-auto").addClass("opacity-0 pointer-events-none");
    menuToggle.find(".icon-burger").removeClass("hidden");
    menuToggle.find(".icon-close").addClass("hidden").removeClass("flex");
    $("body").removeClass("overflow-hidden");
}

// Toggle menú móvil
$(menuToggle).on("click", function () {
    if ($(this).hasClass("js-open")) {
        closeMobileMenu();
    } else {
        openMobileMenu();
    }
});

// Cerrar con tecla ESC
$(document).on("keyup", function (e) {
    if (e.key === "Escape" && menuToggle.hasClass("js-open")) {
        closeMobileMenu();
    }
});

// Cerrar al hacer click en el botón X del menú
$(document).on("click", "#closeMobileMenu", function () {
    closeMobileMenu();
});

// Cerrar al hacer click en el overlay
$(document).on("click", "#mobileMenuOverlay", function () {
    closeMobileMenu();
});

// Cerrar al hacer click en enlaces del menú móvil
$(document).on("click", "#mobileMainMenu a", function (e) {
    if ($(e.target).closest('.lang-dropdown-wrapper').length) {
        return;
    }
    closeMobileMenu();
});
